// extracted by mini-css-extract-plugin
export default {"page":"Z8-z","cartModal":"_8-z","checkout":"a9-z","placeholder":"b9-z","account":"c9-z"};